import React, { useState } from "react";
import PersonalCard from "Assets/Images/Icons/personalCard.png";
import ButtonPrimary from "Components/Buttons/Primary";
import useStoresList from "Hooks/Stores/useStoresList";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import StoreItem from "Views/Stores/List/StoreItem";
import * as Styled from "./styles";

const CarouselWrapper = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  margin: 0;
  position: relative;
`;

const CarouselContent = styled.div<{ translateX: number }>`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 2fr;
  transform: ${({ translateX }) => `translateX(-${translateX}px)`};
  transition: transform 0.3s ease-in-out;
  gap: 16px;
  padding: 12px 44px 12px 44px;

  // deve ter 2 colunas em telas medias
  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    grid-template-columns: repeat(2, 1fr); /* Duas colunas em telas médias */
    padding: 12px 24px;
  }

  // deve ter 1 colunas em telas pequenas
  @media ${({ theme }) => theme.devices.mobileL} {
    width: 100%;
    grid-template-columns: 1fr; /* Apenas uma coluna em telas menores */
  }
`;

const ArrowButton = styled.button<{ position: "left" | "right" }>`
  position: absolute;
  top: 50%;
  ${({ position }) => (position === "left" ? "left: 0px;" : "right: 0px;")}
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 8;
  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;

const StoresHome: React.FC = () => {
  const history = useHistory();

  const { data: response, isLoading, isError } = useStoresList({
    perPage: 100,
  });

  const data =
    response &&
    response.data.sort((a: any, b: any) => {
      const currentDate = new Date();

      if (a.highlight_expires_at === null && b.highlight_expires_at === null)
        return 0;

      if (a.highlight_expires_at === null) return 1;

      if (b.highlight_expires_at === null) return -1;

      const dateA = new Date(a.highlight_expires_at);
      const dateB = new Date(b.highlight_expires_at);

      const diffA = dateA.getTime() - currentDate.getTime();
      const diffB = dateB.getTime() - currentDate.getTime();

      if (diffA >= 0 && diffB >= 0) {
        return diffA - diffB;
      } else if (diffA < 0 && diffB < 0) {
        return diffB - diffA;
      } else if (diffA < 0) {
        return 1;
      } else {
        return -1;
      }
    });

  const [currentIndex, setCurrentIndex] = useState(0);
  const screenWidth = window.innerWidth;
  const isMobileL = screenWidth <= 600;
  const isTablet = screenWidth > 600 && screenWidth <= 1023;
  const itemsPerPage = isMobileL ? 2 : isTablet ? 4 : 6;
  const totalItems = data && data.length >= 6 ? data.length : 6;
  const maxIndex = Math.ceil(totalItems / itemsPerPage) - 1;
  const next = () => {
    if (currentIndex < maxIndex) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const currentItems =
    data && data.length >= 5
      ? data.slice(
          currentIndex * itemsPerPage,
          (currentIndex + 1) * itemsPerPage
        )
      : [];
  return (
    <Styled.Container>
      {data && data.length >= 6 && (
        <Styled.Section>
          <Styled.TopStores>
            <Styled.RightSide>
              <Styled.PersonalCard
                src={PersonalCard}
                alt="Imagem de um card de pessoa"
              />
              <Styled.Title>Lojas Oficiais</Styled.Title>
            </Styled.RightSide>
            <Styled.LeftSide>
              <Styled.ButtonContainer>
                <ButtonPrimary
                  type="button"
                  color="green"
                  action={() => history.push("/lojas-online")}
                  borderRadius="6px"
                >
                  Quero cadastrar minha loja
                </ButtonPrimary>
              </Styled.ButtonContainer>
              <Styled.SeeAllStores>
                <Styled.Link as={Link} to="/stores">
                  Ver todas
                </Styled.Link>
                <FaChevronRight color="#00A859" />
              </Styled.SeeAllStores>
            </Styled.LeftSide>
          </Styled.TopStores>
          <Styled.BodyStores>
            {data.length > itemsPerPage && currentIndex > 0 && (
              <ArrowButton
                position="left"
                onClick={prev}
                disabled={currentIndex === 0}
              >
                <FaChevronLeft size={20} />
              </ArrowButton>
            )}
            <Styled.RightSideMainBody>
              <CarouselWrapper>
                <CarouselContent translateX={0}>
                  {currentItems.map((item: any, index: number) => (
                    <StoreItem
                      key={index}
                      name={item.name}
                      slug={item.slug}
                      banner={item.banner}
                      description={item.description ? item.description : ""}
                    />
                  ))}
                </CarouselContent>
              </CarouselWrapper>
            </Styled.RightSideMainBody>
            {/* <Styled.RightSideMainBody>
              {data.slice(1).map((item: any, index: number) => (
                <StoreItem
                  key={index}
                  name={item.name}
                  slug={item.slug}
                  banner={item.banner}
                  description={item.description ? item.description : ""}
                />
              ))}
            </Styled.RightSideMainBody> */}
            {data.length > itemsPerPage && currentIndex < maxIndex && (
              <ArrowButton
                position="right"
                onClick={next}
                disabled={currentIndex == data!.length - 1}
              >
                <FaChevronRight size={20} />
              </ArrowButton>
            )}
          </Styled.BodyStores>
        </Styled.Section>
      )}
    </Styled.Container>
  );
};

export default StoresHome;
